import React from "react";
import "./Martini.css";

function Martini(props) {
	return (
		<svg
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			x="0px"
			y="0px"
			viewBox="0 0 1000 1000"
			enableBackground="new 0 0 1000 1000"
		>
			<metadata>
				{" "}
				Svg Vector Icons : http://www.onlinewebfonts.com/icon{" "}
			</metadata>
			<g>
				<g transform="translate(0.000000,511.000000) scale(0.100000,-0.100000)">
					<path d="M649.4,4828.5V4647l764.5-4.5l762.2-6.8l299.5-714.6l299.4-714.6l-657.9-11.3c-655.6-11.3-655.6-11.3-698.7-65.8c-22.7-29.5-43.1-70.3-43.1-93c0-22.7,245-1592.5,544.4-3489l544.4-3448.1v-390.2c0-381.1,0-387.9,56.7-442.4l54.4-56.7H4642h2066.6l54.5,56.7c56.7,54.4,56.7,61.3,56.7,458.2l2.3,403.8l415.2,2620.1L7650.1,1369l167.9,15.9c338,34,610.2,136.1,873.4,324.4c585.3,417.4,809.9,1177.4,555.8,1878.3c-179.2,485.5-576.2,846.2-1102.5,995.9c-226.9,63.5-603.4,70.3-825.8,11.3c-567.1-149.7-1041.3-637.5-1177.4-1211.4l-40.8-176.9l-1463.2-6.8l-1463.2-4.5l-22.7,49.9c-11.3,29.5-183.7,437.8-381.1,909.7L2412.1,5010h-880.2H649.4V4828.5z M8146.9,4220.6c494.5-179.2,850.7-676,850.7-1184.2c0-671.5-490-1225-1136.5-1284l-158.8-15.9l11.3,54.4c22.7,93,195.1,1202.3,195.1,1250c0,22.7-25,68.1-56.7,97.5l-54.5,56.7h-660.1h-657.9v56.7c0,83.9,97.5,333.5,179.2,462.8c156.5,242.7,471.9,460.5,782.6,537.6C7616,4297.7,7979,4279.5,8146.9,4220.6z M6999-427.6C6713.2-2222,6481.8-3692,6481.8-3694.3c-2.3-4.6-828-6.8-1839.8-6.8H2804.5l-11.3,52.2c-6.8,27.2-235.9,1479.1-510.4,3225.8c-274.5,1746.8-503.6,3194.1-508.1,3216.8c-9.1,36.3,138.4,38.6,2865.1,38.6h2874.2L6999-427.6z M6456.8-4245.6V-4427H4642H2827.2v181.5v181.5H4642h1814.8V-4245.6z" />
					<path d="M2550.4,2435.2c-34-20.4-68.1-59-77.1-88.5c-18.1-72.6,351.6-2461.4,390.2-2522.6c38.6-63.5,136.1-86.2,213.2-54.5c133.8,56.7,136.1,25-70.3,1363.4c-129.3,843.9-199.6,1243.1-224.6,1270.4C2734.2,2462.5,2625.3,2476.1,2550.4,2435.2z" />
					<path d="M2883.9-491.2c-47.6-47.6-56.7-74.9-56.7-201.9c0-181.5,11.3-211,95.3-254.1c81.7-40.8,158.8-27.2,222.3,40.8c36.3,38.6,45.4,79.4,45.4,204.2c0,136.1-6.8,163.3-56.7,211c-34,36.3-81.7,56.7-124.8,56.7C2965.6-434.4,2917.9-454.9,2883.9-491.2z" />
				</g>
			</g>
		</svg>
	);
} //Martini

export default Martini;
